var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33262 13.6297C7.9667 13.6705 7.66732 13.3682 7.66732 13L7.66732 8.33334C7.66732 7.96515 7.9658 7.66668 8.33399 7.66668H13.0007C13.3688 7.66668 13.6711 7.96606 13.6303 8.33198C13.5679 8.89151 13.4269 9.44059 13.2106 9.96278C12.9091 10.6907 12.4671 11.3522 11.91 11.9093C11.3528 12.4665 10.6914 12.9084 9.96342 13.21C9.44123 13.4263 8.89215 13.5673 8.33262 13.6297Z",
    fill: "#777E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6303 5.66804C13.6711 6.03396 13.3688 6.33334 13.0007 6.33334H8.33398C7.96579 6.33334 7.66732 6.03487 7.66732 5.66668V1.00001C7.66732 0.63182 7.9667 0.329516 8.33262 0.370342C8.89215 0.43277 9.44123 0.573768 9.96342 0.790066C10.6914 1.09159 11.3528 1.53355 11.91 2.0907C12.4671 2.64785 12.9091 3.30929 13.2106 4.03724C13.4269 4.55943 13.5679 5.10851 13.6303 5.66804Z",
    fill: "#777E91"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66864 1.03699C6.03456 0.996175 6.33399 1.29849 6.33399 1.66668L6.33398 12.3333C6.33398 12.7015 6.03456 13.0038 5.66864 12.963C4.32213 12.8128 3.05861 12.2099 2.09134 11.2426C0.966125 10.1174 0.333984 8.59131 0.333984 7.00001C0.333985 5.40871 0.966126 3.88259 2.09134 2.75737C3.05861 1.7901 4.32213 1.1872 5.66864 1.03699Z",
    fill: "#777E91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChart);
export default __webpack_public_path__ + "static/media/icon-chart.bdae1f7f0cf5fcef881418d712f2c900.svg";
export { ForwardRef as ReactComponent };